var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nullimg"},[_c('img',{attrs:{"src":require("../../assets/homePage/1662105414657.png"),"alt":""}})])])
}]

export { render, staticRenderFns }